var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"trans-btn",on:{"click":_vm.openModal}},[_c('img',{staticClass:"trans-icon",attrs:{"src":"/src/assets/icons/translate.svg"}})]),_vm._v(" "),_c('ModalLang',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModalVisible),expression:"isModalVisible"}],attrs:{"translations":_vm.translations,"scope-lang":_vm.locale},on:{"selectLang":_vm.selectLang,"close":_vm.closeModal,"validate":_vm.validateModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61b5b006","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupTranslator.vue
// module id = 971
// module chunks = 0